// QR Kiosk v2 — KV2-6 auth'd bot-image loader (the non-MUI re-take of
// MidasArtifactThumbnail's fetch). Resolves a bot image URL to a blob URL via the
// authed fetchBotImage proxy and revokes it on unmount / url change. §3-T4/§6.
import { useEffect, useState } from "react";
import chatBotApi from "../../../shared/chatBot/ChatBotApi";

export function useBotImage(url?: string): string | null {
  const [blobUrl, setBlobUrl] = useState<string | null>(null);

  useEffect(() => {
    if (!url) {
      setBlobUrl(null);
      return;
    }
    let active = true;
    let created: string | null = null;
    chatBotApi
      .fetchBotImage(url)
      .then((b) => {
        if (active) {
          created = b;
          setBlobUrl(b);
        } else {
          URL.revokeObjectURL(b);
        }
      })
      .catch(() => {
        if (active) setBlobUrl(null);
      });
    return () => {
      active = false;
      if (created) URL.revokeObjectURL(created);
    };
  }, [url]);

  return blobUrl;
}
